"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GRAPHQL_BASE_URL = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _createAppolloClient = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/createAppolloClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query getBrandsDetails($type1: [String]) {\n    getBrandsDetails(brandCd: $type1) {\n      brandCd\n      brandName\n      displayCd\n      brandId\n      uniqueIdendifier\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GRAPHQL_BASE_URL = process.env.NODE_ENV === "production" ? "/gateway_gcs/graphql" : (window.localStorage.getItem("devDomain") || "https://cornerstone-dev.elcompanies.net") + "/gateway_gcs/graphql";
exports.GRAPHQL_BASE_URL = GRAPHQL_BASE_URL;
var client = (0, _createAppolloClient.default)(GRAPHQL_BASE_URL, {
  appName: "BL"
}); //Reference Data Management

var FETCH_BRANDDETAILS = (0, _graphqlTag.default)(_templateObject());

var BLGateway = /*#__PURE__*/function () {
  function BLGateway() {
    _classCallCheck(this, BLGateway);
  }

  _createClass(BLGateway, null, [{
    key: "fetch_brand_details",
    //Reference Data Management
    value: function fetch_brand_details(brandCd) {
      return client.query({
        query: FETCH_BRANDDETAILS,
        variables: {
          type1: brandCd
        }
      });
    }
  }]);

  return BLGateway;
}();

var _default = BLGateway;
exports.default = _default;